import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, ReloadPage } from "@insite/client-framework/Store/Context/Handlers/SetLanguage";

replaceInChain(chain, ReloadPage, props => {
    let href = window.location.href;
    const switchingLanguageParameter = "SwitchingLanguage=true";
    const lang = props?.apiResult?.language?.languageCode;

    if (!href.includes(switchingLanguageParameter)) {
        if (window.location.href.indexOf("?") === -1) {
            href += "?";
        } else {
            href += "&";
        }
        href += switchingLanguageParameter;
    }
    const indexOfLang = href.indexOf("__ptLanguage=");

    if (indexOfLang > -1) {
        href = href.replace(href.substring(indexOfLang, indexOfLang + 18), `__ptLanguage=${lang}`);
    } else {
        href += `?&__ptLanguage=${lang}`;
    }
    window.location.href = href;
});
